import { render, staticRenderFns } from "./Monetizze.vue?vue&type=template&id=9443b2ec&"
import script from "./Monetizze.vue?vue&type=script&lang=js&"
export * from "./Monetizze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports